/**
 * 自定义本地缓存方法
 */
import commonParam from "@/param/commonParam";

/**
 * @description localStorage-存入本地缓存
 * @param {String} key 
 * @param {*} data 
 */
export function saveStorage(key, data) {
  let tk = transKey(key);
  try {
    localStorage.setItem(tk, JSON.stringify(data));
  } catch (e) {
    localStorage.setItem(tk, data);
  }
}

/**
 * @description sessionStorage-存入本地缓存
 * @param {String} key 
 * @param {*} data 
 */
export function saveSessionStorage(key, data) {
  let tk = transKey(key);
  try {
    sessionStorage.setItem(tk, JSON.stringify(data));
  } catch (e) {
    sessionStorage.setItem(tk, data);
  }
}

/**
 * @description localStorage-读取本地缓存
 * @param {String} key 
 * @returns {*}
 */
export function getStorage(key) {
  let tk = transKey(key);
  let jsonStr = localStorage.getItem(tk);
  try {
    return JSON.parse(jsonStr);
  } catch (e) {
    return jsonStr;
  }
}

/**
 * @description sessionStorage-存入本地缓存
 * @param {String} key 
 * @param {*} data 
 */
export function getSessionStorage(key, data) {
  let tk = transKey(key);
  let jsonStr = sessionStorage.getItem(tk);
  try {
    return JSON.parse(jsonStr);
  } catch (e) {
    return jsonStr;
  }
}

/**
 * @description localStorage-删除指定本地缓存
 * @param {String} key 
 */
export function removeStorage(key) {
  let tk = transKey(key);
  localStorage.removeItem(tk);
}

/**
 * @description localStorage-清空本地缓存
 */
export function clearStorage() {
  localStorage.clear();
}

/**
 * @description 编辑键名
 * @param {String} key 
 * @returns {String}
 */
function transKey (key) {
  return commonParam.systemName + "." + key;
}